import { Button as MdButton } from "@mui/material";
import style from "../utils/style";

function Button({
  text,
  variant,
  onClick,
  height,
  isShort,
  color,
  icon,
  extraStyles,
  ...rest
}) {
  return (
    <MdButton
      variant={variant || "contained"}
      onClick={onClick}
      color={color || "primary"}
      size="large"
      fullWidth={!isShort ? true : false}
      startIcon={icon ? icon : null}
      style={{
        minHeight: height || 48,
        padding: height && "3px 8px",
        ...style.marginY1,
        ...extraStyles,
      }}
      {...rest}
    >
      {text}
    </MdButton>
  );
}

export default Button;
